import axios from 'axios'
const request = axios.create({
  baseURL: 'https://dev.zijinshe.com/cms',
  timeout: 5000
})
// 请求拦截器
request.interceptors.request.use(
  config => {
    if (config.url.includes('/mopa')) {
      config.url = config.url.substr(5)
      config.baseURL = 'https://prd.zuul.leziedu.com'
    }
    // 设置请求头
    return config
  },
  error => Promise.reject(error.message)
)
// 响应拦截器
request.interceptors.response.use(
  config => {
    return config.data
  },
  error => Promise.reject(error.message)
)
export default request
